import { createContext } from 'react';

// set initial value of user to null (pre-login)
const UserContext = createContext(null);

export default UserContext;
